













































































































































import * as Moment from "moment";
import Enumerable from "linq";
import { Component, Mixins, Emit, Watch, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { DateDuration } from "../../../domain/system";
import { IDocumentFilterConfiguration } from "../../../domain/configuration/IConfiguration";
import { Directory, IContentSource } from "../../../domain/drawing";
import { Patient } from "../../../domain/patient";
import { User } from "../../../domain/user";
import { Department, DepartmentGroup } from "../../../domain/department";
import { FormatReference } from "../../../domain/format";
import { instanceOfIEntity } from "../../../domain/entity";
import {
  DocumentSummary,
  DocumentSearchPresetCondition,
  DocumentSearchParameter,
  SearchConditionPresetKinds,
  DocumentKind,
} from "../../../domain/document";
import { StandardOption } from "../../system/selectors/mixins";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import { WindowOpener } from "../../system/utilities";
import { DeveloperPresentableMixin } from "../../developer/mixins";
import FoundPatientSelector from "../../patient/selectors/FoundPatientSelector.vue";
import DepartmentDropDownSelector from "../../department/selectors/DepartmentDropDownSelector.vue";
import DocumentDepartmentGroupDialogSelector from "./DocumentDepartmentGroupDialogSelector.vue";
import { DepartmentGroupListSelectorDialog } from "../../department/dialogs";
import { IMultiFormatListSelectorDialogCondition, MultiFormatListSelectorDialog } from "../../format/dialogs";
import SearchConditionPresetEditDialog from "../../document/dialogs/SearchConditionPresetEditDialog.vue";
import ConditionMultiDialogSelector from "../../workflow/selectors/ConditionMultiDialogSelector.vue";
import DocumentDurationKindDropDownSelector from "./DocumentDurationKindDropDownSelector.vue";
import DocumentDurationSelector from "./DocumentDurationSelector.vue";
import DocumentKindDropDownSelector from "./DocumentKindDropDownSelector.vue";
import DocumentManageNumberInput from "./DocumentManageNumberInput.vue";
import { DocumentsFinderPresetMixin } from "./mixins";
import { DocumentDurationOptionsSource } from "./options";
import { IMultiOrderableUserListSelectorDialogCondition } from "../../user/dialogs";
import DocumentUsersSelector from "./DocumentUsersSelector.vue";
import { IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously } from "../../system";
import { IDocumentKindListSelectorDialogCondition } from "../dialogs";

@Component({
  components: {
    durationKindSelector: DocumentDurationKindDropDownSelector,
    durationSelector: DocumentDurationSelector,
    documentKindSelector: DocumentKindDropDownSelector,
    patientSelector: FoundPatientSelector,
    departmentSelector: DepartmentDropDownSelector,
    ConditionMultiDialogSelector,
    DocumentDepartmentGroupDialogSelector,
    manageNumberInput: DocumentManageNumberInput,
    OptionDropDownSelector,
    SearchConditionPresetEditDialog,
    DocumentUsersSelector,
  }
})

export default class DocumentsFinder extends Mixins(DeveloperPresentableMixin, DocumentsFinderPresetMixin) {
  $refs!: {
    presetEditDialog: SearchConditionPresetEditDialog;
    formatSelector: ConditionMultiDialogSelector;
    updateUsersSelector: DocumentUsersSelector;
  };

  @Prop()
  patient: Patient;

  @Prop({ default: "" })
  presetFilterKey: string;

  @Prop({ default: false })
  shouldIgnoreChained: boolean;

  @Prop({ default: false })
  isOtherPatientSelectable: boolean;

  @Prop({ default: true })
  isReady: boolean;

  data(): any {
    return {
      activeNames: ["1"],
      selectedPatient: null,
      patientNo: null,
      isPatientFinding: false,
      isPatientFocused: false,
      duration: DateDuration.today(),
      documentKinds: [],
      department: null as Department,
      isFinding: false,
      documentKindOptions: [],
      departmentOptions: [],
      updateUsers: [],
      isCsvDownloading: false,
      formatSelector: null,
      formats: null,
      isFormatsLoading: false,
      presetFormats: null,
      isOtherPatientNoInputtable: false,
      isPresetInitialized: false,
      patientIdConditionString: "",
      manageNumberConditionString: "",
      containsDeletedConditionString: "",
      containsTemporaryConditionString: "",
      containsRegisteredConditionString: "",
      loginUserOnlyConditionString: "",
      containsVirtualDocumentsConditionString: "",
      durationConditionString: "",
      formatNameConditionString: "",
      documentKindConditionString: "",
      departmentGroupConditionString: "",
      departmentConditionString: "",
      updateUsersConditionString: "",
    };
  }
  activeNames: string[];
  selectedPatient: Patient;
  patientNo: string;
  isPatientFinding: boolean;
  isPatientFocused: boolean;
  duration: DateDuration;
  documentKinds: DocumentKind[];
  department: Department;
  isFinding: boolean;
  departmentOptions: StandardOption<Department>[];
  updateUsers: User[];
  isCsvDownloading: boolean;
  formatSelector: ConditionMultiDialogSelector;
  formats: FormatReference[];
  isFormatsLoading: boolean;
  presetFormats = null as FormatReference[];
  isOtherPatientNoInputtable: boolean;
  isPresetInitialized: boolean;
  patientIdConditionString: string;
  manageNumberConditionString: string;
  containsDeletedConditionString: string;
  containsTemporaryConditionString: string;
  containsRegisteredConditionString: string;
  loginUserOnlyConditionString: string;
  containsVirtualDocumentsConditionString: string;
  durationConditionString: string;
  formatNameConditionString: string;
  documentKindConditionString: string;
  departmentGroupConditionString: string;
  departmentConditionString: string;
  updateUsersConditionString: string;
  allDocumentKinds: DocumentKind[];

  created() {
    if (this.$configuration.behavior.document.list.finder.collapse.shouldShrinkAutomatically) {
      // 将来的にはウィンドウ高さを見て判定する機能を追加するかもだが、現状では未着手
      this.activeNames = [];
    }
  }

  async mounted() {
    this.formatSelector = this.$refs.formatSelector;
    this.registerEvent();
    await this.initializePreset();
  }

  get conditionsString(): string {
    const text = Enumerable.from([
      this.patientIdConditionString,
      this.manageNumberConditionString,
      this.containsDeletedConditionString,
      this.containsTemporaryConditionString,
      this.containsRegisteredConditionString,
      this.loginUserOnlyConditionString,
      this.containsVirtualDocumentsConditionString,
      this.durationConditionString,
      this.formatNameConditionString,
      this.documentKindConditionString,
      this.departmentGroupConditionString,
      this.departmentConditionString,
      this.updateUsersConditionString,
    ])
    .where(t => !!t)
    .toArray()
    .join("");
    return "検索条件：" + (text ? text : "なし");
  }

  get isDocumentDurationDefault(): boolean {
    return (this.isOtherPatientNoInputtable || this.isPatientSelectable)
      ? this.$configuration.behavior.document.list.finder.duration.default.isDocument
      : this.$configuration.behavior.document.list.patientSpecified.finder.duration.default.isDocument;
  }

  get formatConditionIndicationMaxCount(): number {
    return this.$configuration.behavior.document.list.finder.conditionIndication.format.max;
  }

  get selectedPatientDefault(): Patient {
    return this.isPatientSelectable ? null : this.patient;
  }

  get durationDefault(): DateDuration {
    return (this.isOtherPatientNoInputtable || this.isPatientSelectable)
      ? DateDuration.today()
      : new DateDuration(null, null);
  }

  get searchDuration(): DateDuration {
    return this.isManageNumberSpecified
      ? null
      : this.duration;
  }

  get isManageNumberSpecified(): boolean {
    return !!this.manageNumberText;
  }

  get presetFilter(): IDocumentFilterConfiguration {
    if (!this.presetFilterKey) { return; }
    if (!this.$configuration.behavior.document.list.presetFilters) { return; }
    return this.$configuration.behavior.document.list.presetFilters[this.presetFilterKey];
  }

  get multiFormatSelectDialog(): MultiFormatListSelectorDialog {
    return this.$commonDialogs.format.multiListSelector;
  }

  get multiFormatListSelectorDialogCondition(): IMultiFormatListSelectorDialogCondition {
    return {
      name: null,
      containsExpired: true,
      containsDeleted: true,
      shouldIgnoreChained: this.shouldIgnoreChained,
      isMultiSelectable: true,
      shouldIncludeReferenceableGroupFormats: true,
    };
  }

  get multiDocumentKindSelectorDialog(): IMultiSelectableAsynchronously<DocumentKind> & IMultiSelectableConditionallyAsynchronously<DocumentKind, IDocumentKindListSelectorDialogCondition> {
    return this.$commonDialogs.documentKind.multiListSelector;
  }

  get usersSelectDialogCondition(): IMultiOrderableUserListSelectorDialogCondition {
    return {
      departmentId: null,
      isMultiSelectable: null,
      name: null,
      defaultSelectedProfessionCodes: null,
      isMultiSingleSwitchable: true,
    };
  }

  get departmentGroupSelector(): DepartmentGroupListSelectorDialog {
    return this.$commonDialogs.department.groupListSelector;
  }

  get isDepartmentGroupEnable(): boolean {
    return this.$configuration.behavior.departmentGroup.feature.isEnable;
  }

  get isPatientNoInputtable(): boolean {
    return !this.isOtherPatientSelectable || this.isOtherPatientNoInputtable;
  }

  get isSearchDisabled(): boolean {
    return !this.isSearchable || !this.isDurationConditionValid;
  }

  get isDurationConditionValid(): boolean {
    return this.duration
      && this.duration.isValid;
  }

  private formatConditionString(name: string, value: string): string {
    return value
      ? (name + "【" + value + "】")
      : "";
  }

  updateConditionString(): void {
    this.patientIdConditionString = this.formatConditionString("患者番号", this.patientId);
    this.manageNumberConditionString = this.formatConditionString("管理番号", this.manageNumberText);
    this.containsDeletedConditionString = this.formatConditionString("削除済", this.containsDeleted ? "含む" : null);
    this.containsTemporaryConditionString = this.formatConditionString("一時保存", this.containsTemporary ? "含む" : null);
    this.containsRegisteredConditionString = this.formatConditionString("登録済", this.containsRegistered ? "含む" : null);
    this.loginUserOnlyConditionString = this.formatConditionString("ログインユーザ", this.loginUserOnly ? "のみ" : null);

    this.containsVirtualDocumentsConditionString = this.isDeveloperMode
      ? this.formatConditionString("仮想文書", this.containsVirtualDocuments ? "含む" : null)
      : "";

    this.durationConditionString = (!this.searchDuration || (!this.searchDuration.from && !this.searchDuration.to))
      ? null
      : this.formatConditionString(
        "期間(対象)",
        this.toDurationKindString(this.isDurationDocument) + " " + this.toDurationString(this.searchDuration)
      );

    this.formatNameConditionString = this.formatConditionString(
      this.$wording.format.attributes.name + "名",
      this.formatNameCondition
    );
    this.documentKindConditionString = this.formatConditionString(
      this.$wording.format.attributes.name + "種別",
      this.documentKinds.length > 0 ? this.documentKinds.map(k => k.name).join(",") : null
    );
    this.departmentGroupConditionString = this.formatConditionString(
      this.$wording.common.departmentGroup,
      this.departmentGroup ? this.departmentGroup.name : null
    );
    this.departmentConditionString = this.formatConditionString(
      this.$wording.common.department,
      this.department ? this.department.name : null
    );
    this.updateUsersConditionString = this.formatConditionString("作成者", (this.updateUserCodes && this.updateUserCodes.length) ? "指定あり" : null);
  }

  private toDurationKindString(source: boolean): string {
    return source ? "文書日付" : "更新日";
  }

  private toDurationString(source: DateDuration): string {
    if ((source.from && source.to) || (!source.from && !source.to)) {
      const durationString = DocumentDurationOptionsSource.toDurationString(source);
      return durationString
        ? durationString
        : Moment(source.from).format("YY/MM/DD") + " ～ " + Moment(source.to).format("YY/MM/DD");
    } else if (source.from) {
      return Moment(source.from).format("YY/MM/DD") + " ～";
    } else {
      return  "～ " + Moment(source.to).format("YY/MM/DD");
    }
  }

  private toDateDuration(durationName: string): DateDuration {
    const duration = DocumentDurationOptionsSource.toDateDuration(durationName);
    return duration
      ? duration
      : this.durationDefault;
  }

  private async setDocumentKinds(documentKindIds: string[]): Promise<void> {
    if (!documentKindIds || documentKindIds.length === 0) {
      this.documentKinds = [];
      return;
    }
    // TODO: 文書種別が運用途中で削除された場合の対応
    const documentKinds = await this.getDocumentKindsWithCache();
    this.documentKinds = documentKinds.filter(k => documentKindIds.some(id => k.id === id));
  }

  private async getDocumentKindsWithCache(): Promise<DocumentKind[]> {
    if (!this.allDocumentKinds) {
      const repo = DomainRegistry.document.getDocumentKindRepository();
      this.allDocumentKinds = await repo.getAllEntities();
    }
    return this.allDocumentKinds;
  }

  async setDepartment(id: string): Promise<void> {
    if (id) {
      // タイミングによっては診療科オプションを取得できていない場合があるので待機する
      await this.$wait(() => (this.departmentOptions.length > 0), 100);
    }
    this.department = id
      ? this.getOptionValue(this.departmentOptions, id)
      : null;
  }

  async setDepartmentGroup(id: string): Promise<void> {
    this.selectedDepartmentGroup = id
      ? await this.getDepartmentGroup(id)
      : null;
  }

  getOptionValue<T>(options: StandardOption<T>[], id: string): T {
    const option = Enumerable.from(options).firstOrDefault(o => instanceOfIEntity(o.value) && o.value.id === id);
    return option
      ? option.value
      : null;
  }

  private get formatNameCondition(): string {
    return this.formats
      ? this.formats.length > this.formatConditionIndicationMaxCount
        ? this.getFormatNameText(this.formats.slice(0, this.formatConditionIndicationMaxCount)) + " 他" + (this.formats.length - this.formatConditionIndicationMaxCount) + "件"
        : this.getFormatNameText(this.formats)
      : null;
  }

  private getFormatNameText(formats: FormatReference[]): string {
    return Enumerable.from(formats).select(n => n.name).toArray().join(",");
  }

  private registerEvent(): void {
    this.$logger.debug("documentList mounted. addEventListener(postMessage)");
    window.addEventListener("message", this.onChildWindowNotify, false);
  }

  // postMessage 受信用イベントリスナー
  onChildWindowNotify(event: any): void {
    try {
      const message = JSON.parse(event.data);
      this.$logger.debug("postMessage受信");
      console.log(message);

      if (message.key === "documentRegistered" || message.key === "documentNoteRegistered") {
        this.$logger.info((message.key === "documentRegistered") ? "文書が登録されました" : this.$wording.document.note + "が登録されました");
        this.find();
      }
    } catch (e) {
      //
    }
  }

  toArray(source: Directory<string, FormatReference>[], shouldContain: (f: FormatReference) => boolean): FormatReference[] {
    return Enumerable.from(source)
      .select(s => this.directoryToArray(s, shouldContain))
      .aggregate([], (s, f) => s.concat(f));
  }

  directoryToArray(source: Directory<string, FormatReference>, shouldContain: (f: FormatReference) => boolean): FormatReference[] {
    return Enumerable.from(source.entities)
      .where(f => shouldContain(f))
      .concat(this.toArray(source.nodes, shouldContain))
      .toArray();
  }

  isPresetFilterSearchingItem(format: FormatReference): boolean {
    return this.isSearchingName(format.name) || this.isSearchingId(format.id);
  }

  isSearchingName(name: string): boolean {
    return this.presetFilter
      && this.presetFilter.formatName
      && Enumerable.from(this.presetFilter.formatName.split(","))
        .any(n => name.indexOf(n) >= 0);
  }

  isSearchingId(id: number): boolean {
    return this.presetFilter
      && this.presetFilter.formatIds
      && Enumerable.from(this.presetFilter.formatIds.split(","))
        .select(i => Number(i))
        .contains(id);
  }

  setDepartmentOptions(options: StandardOption<Department>[]): void {
    this.departmentOptions = options;
  }

  get isPatientSelectable(): boolean {
    return !this.patient;
  }

  @Watch("patient")
  onPatientUpdated(newValue: Patient, oldValue: Patient): void {
    this.clearPatientNo(); // 選択中のプリセットがクリアされないよう、患者番号だけクリアする
    if (!this.isPresetInitialized && !oldValue && !!newValue) {
      // 患者情報取得のタイミングが遅れると当日での検索条件がセットされてしまう現象があり、対策を追加している
      this.duration = this.durationDefault;
    }
    if (this.isInitialized) {
      this.find();
    }
  }

  @Watch("isFinding")
  onIsFindingUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue !== oldValue) {
      this.changeFinding(newValue);
    }
  }

  @Watch("isOtherPatientNoInputtable")
  onIsOtherPatientNoInputtableUpdated() {
    this.isDurationDocument = this.isDocumentDurationDefault;
    this.duration = this.durationDefault;
  }

  @Emit()
  changeFinding(value: boolean): any {}

  @Emit()
  searchCompleted(result: DocumentSummary[], conditions: string): void {} // v-modelだと検索結果を再ソートするタイミングが難しいので、検索結果をEmitする


  updatePatientFinding(isPatientFinding: boolean): void {
    this.isPatientFinding = isPatientFinding;
  }

  updatePatientFocused(isPatientFocused: boolean): void {
    this.isPatientFocused = isPatientFocused;
  }

  get isSearchable(): boolean {
    return !this.isPatientFinding && !this.isPatientFocused;
  }

  async find(): Promise<void> {
    if (this.isFinding || this.isCsvDownloading) {
      this.$warn("検索処理中", "検索処理を実行中です。");
      return;
    }
    this.updateConditionString();
    this.isFinding = true;
    const repository = DomainRegistry.document.getDocumentRepository();
    try {
      this.$logger.info("文書の検索を開始します。");
      this.presetPatientId = this.patientId;
      this.formatName = "";

      if (!this.selectedPreset.key && this.presetFilter && (this.presetFilter.formatName || this.presetFilter.formatIds)) {
        // onFormatsChanged()でformatsからformatIdsを取得しているが、プリセットフィルターキーでフォーマット名称を指定している場合は
        // IEだとonFormatsChangedの前にfind()に来てしまうため、検索前に取得している
        this.formatIds = this.formats ? Enumerable.from(this.formats).select(n => n.id.toString()).toArray().join(",") : null;
      }

      const result = await repository.searchDocuments(this.condition);
      this.$logger.info("対象文書件数:" + result.summaries.length);
      this.isFinding = false;
      if (result.isExceededMaxRecordCountLimit && this.$configuration.behavior.document.list.finder.notification.limitExceed.isEnable) {
        this.$warn("文書検索", this.$configuration.behavior.document.list.finder.notification.limitExceed.message);
      }
      if (result.summaries.length === 0) {
        this.$warn("対象文書なし", "文書が見つかりませんでした。");
      }
      this.searchCompleted(result.summaries, this.conditionsString);
    } catch (e) {
        this.isFinding = false;
        this.$error("文書検索失敗", "文書検索失敗しました。", e);
        this.searchCompleted([], "文書検索失敗");
    }
  }

  async downloadCsv(): Promise<void> {
    if (this.isFinding || this.isCsvDownloading) {
      this.$warn("検索処理中", "検索処理を実行中です。");
      return;
    }
    this.isCsvDownloading = true;
    const repository = DomainRegistry.document.getDocumentRepository();
    try {
      this.$logger.info("文書の検索（CSV出力）を開始します。");
      const source = await repository.searchDocumentsAndCreateCsv(this.condition);
      this.downloadContent(source);
      this.isCsvDownloading = false;
    } catch (e) {
        this.isCsvDownloading = false;
        this.$error("文書検索失敗", "文書検索（CSV出力）失敗しました。", e);
    }
  }

  downloadContent(source: IContentSource): void {
    // ページ遷移せずにダウンロード通知バーを表示させる
    window.location.href = WindowOpener.toUrl(source.source, {});
  }

  get isCsvButtonVisible(): boolean {
    return this.$configuration.behavior.document.list.csv.isEnable;
  }

  private get patientId(): string {
    return !this.selectedPatient
      ? null
      : this.selectedPatient.id;
  }

  private get fromAsYyyyMmDd(): string {
    return !this.searchDuration
      ? null
      : this.toYyyyMmDd(this.searchDuration.from);
  }

  private get toAsYyyyMmDd(): string {
    return !this.searchDuration
      ? null
      : this.toYyyyMmDd(this.searchDuration.to);
  }

  private toYyyyMmDd(source: Date): string {
    return !source
      ? null
      : Moment(source).format("YYYYMMDD");
  }

  clear() {
    this.clearPatientNo();
    this.isDurationDocument = this.isDocumentDurationDefault;
    this.duration = this.durationDefault;
    this.documentKinds = [];
    this.department = null;
    this.departmentGroup = null;
    this.containsDeleted = false;
    this.containsTemporary = true;
    this.containsRegistered = true;
    this.loginUserOnly = false;
    this.containsVirtualDocuments = false;
    this.formats = null;
    this.manageNumberText = null;
    this.updateUsers = [];
    this.updateUserCodes = [];
  }

  clearPatientNo(): void {
    this.selectedPatient = this.selectedPatientDefault;
    this.patientNo = "";  // PatientFinderMixinのpatientNoの更新を促すため
    this.$nextTick(() => {
      this.patientNo = null;
    });
    if (this.isOtherPatientSelectable && this.patientNo !== this.patientId) {
      this.$nextTick(() => {
        this.patientNo = this.patientId;
      });
    }
  }

  get hasPreset(): boolean {
    return this.presetConditions.length > 0;
  }

  get isPresetEnable(): boolean {
    return !this.isPresetLoading && !this.isProcessiong;
  }

  get defaultDocumentSearchParameter(): DocumentSearchParameter {
    const user = this.$store.getters.user as User;
    const parameter = new DocumentSearchParameter();
    parameter.patientId = this.patientId;
    parameter.fromDate = this.toYyyyMmDd(this.durationDefault.from);
    parameter.toDate = this.toYyyyMmDd(this.durationDefault.to);
    parameter.durationName = this.toDurationString(this.durationDefault);
    if (this.$configuration.behavior.departmentGroup.scope.isEnable) {
      // この機能を唯一使用している相澤病院ではデフォルトで施設の絞り込み不要のため、デフォルト選択無しとしている
      // もし将来的に参照可能施設の機能を使う案件が出たときに設定追加を検討する
      parameter.departmentGroupId = null;
      parameter.departmentIds = null;
    } else {
      parameter.departmentGroupId = (this.isDepartmentGroupEnable && this.$store.getters.departmentGroup) ? this.$store.getters.departmentGroup.id : null;
      parameter.departmentIds = this.toPresetDepartmentIds(this.$store.getters.departmentGroup);
    }
    parameter.departmentId = null;
    parameter.containsDeleted = false;
    parameter.containsTemporary = true;
    parameter.containsRegistered = true;
    parameter.documentKindIds = [];
    parameter.loginUserId = user.id;
    parameter.contentDateSearch = this.isDocumentDurationDefault;
    parameter.loginUserOnly = false;
    parameter.formatName = null;
    parameter.formatIds = null;
    parameter.manageNumberText = null;
    parameter.containsVirtualDocuments = false;
    parameter.updateUserCodes = [];
    return parameter;
  }

  get presetFilterParameter(): DocumentSearchParameter {
    if (!this.presetFilter) { return null; }
    const user = this.$store.getters.user as User;
    const documentKindIds = this.presetFilter.documentKindIds ? this.presetFilter.documentKindIds.concat() : [];
    if (this.presetFilter.documentKind && documentKindIds.indexOf(this.presetFilter.documentKind) < 0) {
      documentKindIds.push(this.presetFilter.documentKind);
    }
    const parameter = new DocumentSearchParameter();
    parameter.patientId = this.patientId;
    parameter.fromDate = this.toYyyyMmDd(this.durationDefault.from);
    parameter.toDate = this.toYyyyMmDd(this.durationDefault.to);
    parameter.durationName = this.getPresetFilterStringValue(this.presetFilter.durationPresetName, this.toDurationString(this.durationDefault));
    parameter.departmentGroupId = null;
    parameter.departmentIds = null;
    parameter.departmentId = this.getPresetFilterStringValue(this.presetFilter.departmentCode, null);
    parameter.containsDeleted = this.getPresetFilterBooleanValue(this.presetFilter.containsDeleted, false);
    parameter.containsTemporary = this.getPresetFilterBooleanValue(this.presetFilter.containsTemporary, true);
    parameter.containsRegistered = this.getPresetFilterBooleanValue(this.presetFilter.containsRegistered, true);
    parameter.documentKindIds = documentKindIds;
    parameter.loginUserId = user.id;
    parameter.contentDateSearch = this.getPresetFilterBooleanValue(this.presetFilter.isDurationDocument, this.isDocumentDurationDefault);
    parameter.loginUserOnly = this.getPresetFilterBooleanValue(this.presetFilter.isLoginUserOnly, false);
    parameter.formatName = this.getPresetFilterStringValue(this.presetFilter.formatName, null);
    parameter.formatIds = this.getPresetFilterStringValue(this.presetFilter.formatIds, null);
    parameter.manageNumberText = null;
    parameter.containsVirtualDocuments = false;
    parameter.updateUserCodes = this.presetFilter.updateUserCodes ? this.presetFilter.updateUserCodes.concat() : [];
    return parameter;
  }

  get latestPreset(): DocumentSearchPresetCondition {
    const latestPersonPreset = this.getLatestPreset(SearchConditionPresetKinds.Person);
    if (latestPersonPreset) { return this.toDefaultSelected(latestPersonPreset); }

    const latestDepartmentPreset = this.getLatestPreset(SearchConditionPresetKinds.Department);
    if (latestDepartmentPreset) { return this.toDefaultSelected(latestDepartmentPreset); }

    const latestAllPreset = this.getLatestPreset(SearchConditionPresetKinds.All);
    if (latestAllPreset) { return this.toDefaultSelected(latestAllPreset); }

    return this.toDefaultSelected(this.defaultCondition);
  }

  get defaultCondition(): DocumentSearchPresetCondition {
    const condition = new DocumentSearchPresetCondition();
    condition.key = "";
    condition.name = "";
    condition.condition = this.defaultDocumentSearchParameter.clone();
    condition.presetKind = SearchConditionPresetKinds.Person;
    condition.index = 0;
    condition.departmentId = "";
    condition.isDefaultSelected = false;
    return condition;
  }

  get defaultSelectedPreset(): DocumentSearchPresetCondition {
    const defaultSelectedPreset = this.presetConditions.find(p => p.isDefaultSelected);
    return defaultSelectedPreset
      ? defaultSelectedPreset
      : this.latestPreset;
  }

  get presetFilterCondition(): DocumentSearchPresetCondition {
    if (!this.presetFilterKey) { return null; }
    const preset = new DocumentSearchPresetCondition();
    preset.presetKind = SearchConditionPresetKinds.Person;
    preset.condition = this.presetFilterParameter;
    preset.name = this.presetFilterKey;
    preset.isDefaultSelected = true;
    preset.index = 0;
    return preset;
  }

  get isLoading(): boolean {
    return this.isPresetLoading || this.isPatientFinding || this.isFormatsLoading;
  }

  get isProcessiong(): boolean {
    return this.isFinding || this.isCsvDownloading;
  }

  async showPresetEditDialog(): Promise<void> {
    const presetKey = await this.$refs.presetEditDialog.show(this.sortedSearchPresetConditions, this.selectedPreset, this.departmentId);
    if (presetKey) {
      this.isPresetLoading = true;
      this.presetConditions = await this.getPresetConditions(this.departmentId);
      this.sortedPresetKeys = await this.getPresetOrder();
      const preset = this.presetConditions.find(p => p.key === presetKey);
      this.selectPreset(preset ? preset : this.defaultSelectedPreset);
      this.isPresetLoading = false;
    }
  }

  async getFormats(shouldIgnoreChained: boolean, shouldContain: (f: FormatReference) => boolean): Promise<FormatReference[]> {
    try {
      const repository = DomainRegistry.format.getFormatRepository();
      const formats = await repository.getFormats(shouldIgnoreChained, true);
      return this.toArray(formats, shouldContain);
    } catch (e) {
      this.$error(
        this.$wording.format.name + "情報取得失敗",
        this.$wording.format.name + "情報を取得できませんでした。",
        e
      );
    }
  }

  async setPresetCondition(): Promise<void> {
    this.isPresetLoading = true;

    this.duration = this.durationName
      ? this.toDateDuration(this.durationName)
      : this.durationDefault;

    await this.setDocumentKinds(this.documentKindIds);
    await this.setDepartment(this.presetDepartmentId);
    await this.setDepartmentGroup(this.departmentGroupId);

    this.formats = (this.formatName || this.formatIds)
      ? await this.getFormats(this.containsVirtualDocuments, this.isPresetFormat)
      : null;

    this.isPresetLoading = false;
  }

  selectPreset(preset: DocumentSearchPresetCondition): void {
    if (this.isPresetOptionCondition(preset)) {
      this.selectedPresetOption = preset.clone();
    } else {
      this.selectedPresetOption = null;
      this.applyPreset(preset.clone());
    }
  }

  applyPreset(preset: DocumentSearchPresetCondition): void {
    this.isPresetLoading = true;
    this.preset = this.resetSearchParameter(preset);
    this.isPresetLoading = false;
  }

  resetSearchParameter(preset: DocumentSearchPresetCondition): DocumentSearchPresetCondition {
    const user = this.$store.getters.user as User;
    preset.condition.loginUserId = user.id;
    if (!this.isDeveloperMode) {
      preset.condition.containsVirtualDocuments = false;
    }
    // 診療科グループ(施設)設定無効時、departmentCode指定ログイン時の診療科グループ(施設)はDepartmentSelectableMixinで捨てているが
    // プリセットが存在する場合その診療科グループ(施設)とIDは選択される為無効に
    if (!this.isDepartmentGroupEnable) {
      preset.condition.departmentGroupId = null;
      preset.condition.departmentIds = null;
    }
    if (this.$store.getters.isDepartmentGroupScopeEnable) {
      const visibleDepartmentGroups = (this.$store.getters.referenceableDepartmentGroups as DepartmentGroup[]).concat();
      if (this.$store.getters.departmentGroup) {
        visibleDepartmentGroups.push(this.$store.getters.departmentGroup);
      }
      if (preset.condition.departmentGroupId) {
        if (Enumerable.from(visibleDepartmentGroups).all(g => g.id !== preset.condition.departmentGroupId)) {
          preset.condition.departmentGroupId = null;
          preset.condition.departmentIds = null;
          this.$warn("検索条件", "参照指定されていない" + this.$configuration.wording.common.departmentGroup + "がプリセットに指定されています。検索条件にセットできませんでした。");
        }
      }
      if (preset.condition.departmentId) {
        const visibleDepartments = Enumerable.from(visibleDepartmentGroups)
          .selectMany(g => g.departments)
          .toArray();
        if (Enumerable.from(visibleDepartments).all(g => g.id !== preset.condition.departmentId)) {
          preset.condition.departmentId = null;
          this.$warn("検索条件", "参照指定されていない" + this.$configuration.wording.common.departmentGroup + "の" + this.$configuration.wording.common.department + "がプリセットに指定されています。検索条件にセットできませんでした。");
        }
      }
    }
    return preset;
  }

  async initializePreset(): Promise<void> {
    this.isPresetLoading = true;
    this.sortedPresetKeys = await this.getPresetOrder();
    this.presetConditions = await this.getPresetConditions(this.departmentId);
    if (!this.isReady) {
      // 患者情報取得のタイミングが遅れると当日での検索条件がセットされてしまう現象があり、対策を追加している
      await this.$wait(() => this.isReady);
      await this.$nextTick();
    }
    if (this.presetFilter) {
      this.applyPreset(this.presetFilterCondition);
    } else {
      if (this.presetFilterKey) {
        // 存在しないpresetFilterKeyを指定されている場合ここを通る
        this.$error("検索条件", "指定された検索条件「" + this.presetFilterKey + "」が見つかりませんでした。");
      }
      this.selectPreset(this.defaultSelectedPreset);
    }
    this.isPresetLoading = false;
  }

  async getDepartmentGroup(groupId: string): Promise<DepartmentGroup> {
    try {
      if (!groupId) { return null; }
      const repository = DomainRegistry.department.getDepartmentRepository();
      const result = await repository.getDepartmentGroup(groupId);
      return result;
    } catch (e) {
      this.$error(
        this.$wording.common.departmentGroup + "取得失敗",
        this.$wording.common.departmentGroup + "情報の取得に失敗しました。",
        e
      );
    }
  }

  @Watch("selectedPresetOption")
  onSelectedPresetOptionChanged(newValue: DocumentSearchPresetCondition) {
    if (newValue) {
      this.applyPreset(newValue.clone());
    }
  }

  @Watch("selectedPreset")
  async onSelectedPresetChanged(newValue: DocumentSearchPresetCondition) {
    if (newValue) {
      await this.setPresetCondition();
      if (this.isInitialized) {
        this.find();
      }
      this.isPresetInitialized = true;
    }
  }

  get isInitialized(): boolean {
    return this.isReady && this.isPresetInitialized;
  }

  @Watch("isInitialized")
  onIsInitializedChanged(newValue: boolean) {
    if (newValue) {
      this.find();
    }
  }

  @Watch("searchDuration")
  onSearchDurationChanged(newValue: DateDuration) {
    this.durationName = newValue ? this.toDurationString(newValue) : "";
    this.fromDate = this.fromAsYyyyMmDd;
    this.toDate = this.toAsYyyyMmDd;
  }

  @Watch("updateUsers")
  onUpdateUsersChanged(newValue: User[]) {
    this.updateUserCodes = newValue ? newValue.map(u => u.id) : [];
  }

  @Watch("updateUserCodes")
  onUpdateUserCodesChanged(newValue: string[]) {
    // プリセット由来でuserCodeが格納されたとき、表示と不一致になるので更新するようにしている
    // nextTickが無いと不必要に更新しなおしてしまうので待つようにしている
    this.$nextTick(() => {
      this.$refs.updateUsersSelector.setUsersSelection(newValue);
    });
  }
}
